export interface Currency {
    symbol: string;
    isoCode: string;
}
const CurrencyIsoCodes = {
  EUR: "EUR",
  USD: "USD",
  GBP: "GBP",
  AUD: "AUD",
  CAD: "CAD"  
};

const GetAllCurrencies = () => {
    return <Currency[]> [
        { symbol: "€", isoCode: CurrencyIsoCodes.EUR },
        { symbol: "$", isoCode: CurrencyIsoCodes.USD },
        { symbol: "£", isoCode: CurrencyIsoCodes.GBP },
        { symbol: "A$", isoCode: CurrencyIsoCodes.AUD },
        { symbol: "C$", isoCode: CurrencyIsoCodes.CAD },
    ];
}

const GetEurCurrency = () => {
    return <Currency> { symbol: "€", isoCode: CurrencyIsoCodes.EUR };
}

export { CurrencyIsoCodes, GetAllCurrencies, GetEurCurrency };